<div class="chart">
  <canvas [id]="uuid"></canvas>
</div>
